export default __webpack_public_path__ + "static/media/bodrumqueen7.0187ff29.jpg";